import { useEffect, useState, useRef } from "react";
import { getAllTests, getComparableResultsAll } from "../../../services/Model";
import TestHeaders from "./TestHeaders";
import TestFooter from "../TestFooter";
import AllResults from "./AllResults";
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { generateReportPDF } from "../../../utils/pdfExport";

const AllReports = ({ print }) => {
  const [Tests, setTests] = useState([]);
  const [AllTests, setAllTests] = useState();
  const [HeadInfo, setHeadInfo] = useState();
  const { pid, tid } = useParams();
  const printRef = useRef();
  const navigate = useNavigate();

  const generatePDF = () => {
    generateReportPDF(printRef, HeadInfo, pid, tid);
  };

  useEffect(() => {
    const fetchAllTests = async () => {
      var test_res = await getAllTests(pid, tid);

      // console.log(test_res);
      // Filtering Results based on Gender
      test_res = test_res.data.rows.filter(
        (tr) =>
          (tr.RESULT_GENDER === "N" || tr.RESULT_GENDER === tr.GENDER) &&
          (tr.AGERANGE === "N" || tr.AGERANGE === "A"),
      );

      const result = test_res.reduce(function (r, a) {
        r[a.TESTCODE] = r[a.TESTCODE] || [];
        r[a.TESTCODE].push(a);
        return r;
      }, Object.create(null));

      // console.log(result);

      const tests = Object.values(result).map((r) => {
        var rr2 = [];
        rr2["TESTNAME"] = r[0]["TESTNAME"];
        rr2["TESTCODE"] = r[0]["TESTCODE"];
        rr2["PINFO"] = Object.keys(r[0])
          .filter(
            (key) =>
              key.includes("NAME") ||
              key.includes("PID") ||
              key.includes("GENDER") ||
              key.includes("TEST") ||
              key.includes("DOBIRTH"),
          )
          .reduce((cur, key) => {
            return Object.assign(cur, { [key]: r[0][key] });
          }, {});
        rr2["RESULT"] = r.reduce(function (r, a) {
          r[a.PARAMETERCODE] = r[a.PARAMETERCODE] || [];
          r[a.PARAMETERCODE].push(a);
          return r;
        }, Object.create(null));
        return rr2;
      });

      console.log(tests);
      setHeadInfo(tests[0]["PINFO"]);
      setTests(tests);
      fetchAllComparable();
    };
    fetchAllTests();

    const fetchAllComparable = async () => {
      const c = await getComparableResultsAll(pid);
      // console.log(c.data.rows);
      setAllTests(c.data.rows);
    };
  }, [pid, tid]);

  // console.log(HeadInfo);
  return (
    <div>
      <Helmet>
        <title>FOH Lab Online - Test Results</title>
      </Helmet>
      {HeadInfo && (
        <TestHeaders
          header={HeadInfo}
          print={print}
          pid={pid}
          printRef={printRef}
        />
      )}
      <div
        ref={printRef}
        className={Tests.length > 0 && AllTests ? "pdf-ready" : ""}
      >
        {Tests.map((t, i) => {
          return (
            <div className="thi-wrapper" key={i} style={{ marginTop: "100px" }}>
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#0d6efd",
                  marginBottom: "20px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {t["TESTNAME"]}
              </h3>
              {AllTests && (
                <AllResults
                  results={t["RESULT"]}
                  oldResults={AllTests.filter(
                    (a) =>
                      a.TESTCODE === t["TESTCODE"] &&
                      (a.RESULT_GENDER === "N" ||
                        a.RESULT_GENDER === t["PINFO"].GENDER) &&
                      (a.AGERANGE === "N" || a.AGERANGE === "A"),
                  )}
                />
              )}
            </div>
          );
        })}
        <TestFooter />
      </div>

      {!print && (
        <div className="text-center my-4 no-print">
          <button
            title="Generate PDF Report"
            className="btn btn-success btn-lg me-2"
            onClick={generatePDF}
          >
            <i className="fas fa-file-pdf me-2"></i>Download PDF
          </button>
          <button
            title="Print Report"
            className="btn btn-outline-success btn-lg me-2"
            onClick={() => window.print()}
          >
            <i className="fas fa-print me-2"></i>Print
          </button>
          <button
            title="Close"
            className="btn btn-outline-secondary btn-lg"
            onClick={() => navigate('/')}
          >
            <i className="fas fa-times me-2"></i>Close
          </button>
        </div>
      )}
    </div>
  );
};

export default AllReports;
